import { useApi } from '@/api';
import type { GetRevenueSummaryResponse } from '@/api/handlers/resources/sales/responses/GetRevenueSummaryResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export const useRevenueSummaryQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetRevenueSummaryResponse>>({
        queryKey: SalesQueryKeys.revenueSummary(),
        queryFn: () => apiClient.sales.getRevenueSummary(),
        enabled: enabled,
        staleTime: 60_000,
    });
};
